import React from 'react';
import { QuestionLayout } from '../layout/QuestionLayout';
import { getTestId } from '../../utils/testUtils';

interface QuestionFlowEmptyStateProps {
  flowName: string;
}

export const QuestionFlowEmptyState: React.FC<QuestionFlowEmptyStateProps> = ({ flowName }) => (
  <QuestionLayout {...getTestId(`flow-${flowName}`)} progress={0}>
    <div className="flex h-[60vh] items-center justify-center">
      <p className="text-sm text-muted-foreground" {...getTestId('flow-no-questions-message')}>
        No questions available
      </p>
    </div>
  </QuestionLayout>
);
